import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: true,
})
export class HighlightPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: string, search: string, cssClass = 'bold') {
        if (!search?.length) {
            return value;
        }

        try {
            const pattern = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            const regex = new RegExp(pattern, 'gi');
            const match = value.match(regex);

            if (!match) {
                return value;
            }

            const highlighted = value.replace(regex, `<span class="${cssClass}">$&</span>`);

            return this.sanitizer.bypassSecurityTrustHtml(highlighted);
        } catch (e) {
            return value;
        }
    }
}
